// KWB Custom App Styles and Interactions — Consolidated Stable Build
(function() {
  document.documentElement.style.scrollbarGutter = 'stable';

  const style = document.createElement('style');
  style.textContent = `
      /* ============ KWB KNIFE PRODUCT PAGE ============ */
      body, p, li, span, h3, div, input, button {
        font-size: 15px !important;
      }
      
      .kwb-hero {
        position: relative;
        width: 100%;
        height: 38vw;
        min-height: 200px;
        max-height: 360px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      .kwb-hero__image {
        position: absolute;
        inset: 0;
      }
      .kwb-hero__image img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        object-position: center 70% !important;
        filter: brightness(0.60);
      }
      .kwb-hero__overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.7);
      }
      .kwb-hero__content {
        position: relative;
        z-index: 2;
        padding: 24px;
        width: 100%;
        text-align: center;
      }
      .kwb-hero__badge {
        display: inline-block;
        background: rgba(20,15,8,0.6);
        border: 1px solid rgba(122,154,176,0.35);
        color: #7a9ab0;
        font-size: 12px !important;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        padding: 6px 14px;
        border-radius: 30px;
        margin-bottom: 12px;
        backdrop-filter: blur(6px);
      }
      .kwb-hero__title {
        font-size: clamp(1.6rem, 3.8vw, 2.8rem) !important;
        font-weight: 300;
        color: #ffffff;
        letter-spacing: 0.02em;
        line-height: 1.2;
        margin: 0;
      }

      /* Image Grid */
      .kwb-image-grid {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        gap: 3px;
        background: #000;
      }
      .kwb-image-grid__item img {
        width: 100%;
        height: 280px;
        object-fit: cover;
        display: block;
      }
      @media (max-width: 640px) {
        .kwb-image-grid {
          grid-template-columns: 1fr 1fr;
        }
        .kwb-image-grid__item--large {
          grid-column: 1 / -1;
        }
        .kwb-image-grid__item img {
          height: 220px;
        }
      }

      /* Description */
      .kwb-description {
        background: #1a1a1a;
        padding: 52px 24px;
        text-align: center;
        border-top: 1px solid rgba(255,255,255,0.06);
      }
      @media (min-width: 768px) {
        .kwb-description {
          padding: 64px 48px;
        }
      }
      .kwb-description__tagline {
        font-size: clamp(1.5rem, 3.8vw, 2.2rem) !important;
        font-weight: 300;
        line-height: 1.3;
        color: #e8e8e8;
        max-width: 680px;
        margin: 0 auto 28px;
        letter-spacing: -0.01em;
      }
      .kwb-description__body {
        font-size: 16px !important;
        line-height: 1.85;
        color: #999999;
        max-width: 640px;
        margin: 0 auto;
      }
      .kwb-description__body p {
        margin: 0 0 16px;
      }
      .kwb-description__body p:last-child {
        margin: 0;
      }

      /* Maker Quote */
      .kwb-maker-quote {
        background: #0d0d0d;
      }
      .kwb-maker-quote__image {
        position: relative;
        width: 100%;
      }
      .kwb-maker-quote__image img {
        width: 100%;
        height: 380px;
        object-fit: cover;
        display: block;
      }
      .kwb-maker-quote__caption {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,0.65);
        color: #888888;
        font-size: 12px !important;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        text-align: center;
        padding: 10px;
      }
      .kwb-maker-quote__text {
        padding: 36px 24px 40px;
      }
      @media (min-width: 768px) {
        .kwb-maker-quote__text {
          padding: 44px 48px 52px;
          max-width: 720px;
        }
      }
      .kwb-maker-quote__quote {
        font-size: 17px !important;
        line-height: 1.8;
        font-style: normal;
        color: #cccccc;
        margin: 0 0 20px;
        border-left: 2px solid #7a9ab0;
        padding-left: 20px;
      }
      .kwb-maker-quote__author {
        font-size: 12px !important;
        font-weight: 700;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: #7a9ab0;
        font-style: normal;
      }

      /* Buy Section */
      .kwb-buy {
        flex: 1 1 45%;
        background: #111111;
        padding: 24px 20px 32px;
        border-left: none;
      }
      @media (min-width: 900px) {
        .kwb-buy {
          padding: 32px 32px 40px 24px;
          border-left: 1px solid rgba(255,255,255,0.07);
        }
      }
      .kwb-buy__price-row {
        margin-bottom: 10px;
      }
      .kwb-buy__label {
        font-size: 14px !important;
        font-weight: 400;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #888888;
        margin: 0 0 6px;
      }
      .kwb-buy__price-now {
        display: block;
        font-size: 2.2rem !important;
        font-weight: 400;
        color: #e8e8e8;
        letter-spacing: -0.01em;
      }
      .kwb-buy__price-was {
        display: inline-block;
        font-size: 1.2rem !important;
        color: #666666;
        text-decoration: line-through;
        margin-bottom: 4px;
      }
      .kwb-buy__rating {
        margin-bottom: 8px;
        min-height: 20px;
      }
      .kwb-buy__tax {
        font-size: 13px !important;
        color: #666666;
        margin: 0 0 18px;
      }
      .kwb-buy__form {
        margin-bottom: 10px;
      }
      .kwb-buy__button {
        display: block;
        width: 100%;
        background: #2a7a4b;
        color: #ffffff;
        border: none;
        padding: 14px 24px;
        font-size: 14px !important;
        font-weight: 600;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        cursor: pointer;
        border-radius: 30px;
        transition: background 0.2s ease, transform 0.1s ease;
      }
      .kwb-buy__button:hover {
        background: #348f5a;
        transform: translateY(-1px);
      }
      .kwb-buy__button:active {
        transform: translateY(0);
      }
      .kwb-buy__button--sold-out {
        background: #333333 !important;
        color: #777777 !important;
        cursor: not-allowed !important;
        transform: none !important;
      }
      .kwb-buy__klarna {
        font-size: 13px !important;
        color: #777777;
        text-align: center;
        margin: 10px 0 24px;
        padding: 10px 0;
        border-top: 1px solid rgba(255,255,255,0.06);
        border-bottom: 1px solid rgba(255,255,255,0.06);
      }

      /* ---- WHAT'S INCLUDED ---- */
      .kwb-included {
        margin-top: 24px;
        background: #1a1a1a;
        border: 1px solid rgba(255,255,255,0.05);
        padding: 28px 24px;
        border-radius: 4px;
      }
      .kwb-included__title {
        font-size: 12px !important;
        font-weight: 500 !important;
        letter-spacing: 0.15em !important;
        text-transform: uppercase;
        color: #7a9ab0 !important;
        margin: 0 0 16px;
      }
      .kwb-included__content ul {
        list-style: none !important;
        padding: 0 !important;
        margin: 0 0 24px !important;
      }
      .kwb-included__content li {
        position: relative;
        padding-left: 24px;
        margin-bottom: 5px;
        font-size: 14.5px !important;
        color: #eeeeee;
        line-height: 1.5;
      }
      .kwb-included__content li::before {
        content: '✓';
        position: absolute;
        left: 0;
        top: 0;
        color: #7a9ab0;
        font-size: 15px !important;
        font-weight: bold;
      }
      .kwb-included__guarantee {
        background: rgba(122, 154, 176, 0.06);
        border-left: 2px solid #7a9ab0;
        padding: 16px 20px;
        border-radius: 0 4px 4px 0;
      }
      .kwb-included__guarantee strong {
        display: block;
        font-size: 13px !important;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #7a9ab0;
        margin-bottom: 6px;
      }
      .kwb-included__guarantee p {
        font-size: 14px !important;
        color: #cccccc;
        margin: 0;
        line-height: 1.6;
      }
      .details-below {
        font-size: 14px !important;
        color: #777777;
        margin: 0;
        padding: 20px 10px 0px;
        line-height: 1.6;
      }

      /* Product Accordions */
      .kwb-accordion--product {
        background: #111111;
        border-radius: 0 !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: none !important;
        border-top: 1px solid rgba(255,255,255,0.08) !important;
        padding: 0 24px !important;
        margin: 0 !important;
      }
      .kwb-accordion--product:last-of-type {
        border-bottom: 1px solid rgba(255,255,255,0.08) !important;
      }
      
      .kwb-accordion__content a {
        color: #8c8c8c !important;
        transition: color 0.2s ease;
      }
      .kwb-accordion__content a:hover {
        color: #7a9ab0 !important;
      }

      /* Making of This Knife */
      .kwb-story {
        background: #0d0d0d;
        border-top: 1px solid rgba(255,255,255,0.06);
      }
      .kwb-story__image img {
        width: 100%;
        height: 300px;
        object-fit: cover;
        display: block;
      }
      .kwb-story__content {
        padding: 40px 24px 48px;
      }
      @media (min-width: 768px) {
        .kwb-story__content {
          padding: 52px 48px 60px;
          max-width: 780px;
        }
      }
      .kwb-story__title {
        font-size: 1.8rem !important;
        font-weight: 300;
        color: #e8e8e8;
        margin: 0 0 24px;
        letter-spacing: -0.01em;
      }
      .kwb-story__text {
        font-size: 15px !important;
        line-height: 1.95;
        color: #999999;
      }

      /* Reviews */
      .kwb-reviews {
        background: #111111;
        padding: 48px 24px;
        border-top: 1px solid rgba(255,255,255,0.06);
      }
      @media (min-width: 768px) {
        .kwb-reviews {
          padding: 56px 48px;
        }
      }
      .kwb-reviews__title {
        font-size: 1.6rem !important;
        font-weight: 300;
        color: #e8e8e8;
        margin: 0 0 28px;
        letter-spacing: -0.01em;
      }

      /* You Might Also Like */
      .kwb-related {
        background: #1a1a1a;
        padding: 48px 24px;
        border-top: 1px solid rgba(255,255,255,0.06);
      }
      @media (min-width: 768px) {
        .kwb-related {
          padding: 56px 48px;
        }
      }
      .kwb-related__header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 24px;
      }
      .kwb-related__title {
        font-size: 1.6rem !important;
        font-weight: 300;
        color: #e8e8e8;
        margin: 0;
      }
      .kwb-related__view-all {
        font-size: 13px !important;
        color: #7a9ab0;
        text-decoration: none;
        letter-spacing: 0.06em;
      }
      .kwb-related__view-all:hover {
        color: #9ab8cc;
      }
      .kwb-related__grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
      }
      @media (min-width: 768px) {
        .kwb-related__grid {
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }
      }
      .kwb-related__item {
        text-decoration: none;
        color: inherit;
        display: block;
      }
      .kwb-related__image {
        position: relative;
        overflow: hidden;
        aspect-ratio: 1 / 1;
        background: #151515;
        border: 1px solid rgba(255,255,255,0.05);
        border-radius: 4px;
        margin-bottom: 12px;
      }
      .kwb-related__image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        transition: transform 0.4s ease;
      }
      .kwb-related__item:hover .kwb-related__image img {
        transform: scale(1.03);
      }
      
      /* Claude Layout Overlay Rules Optimized */
      .kwb-related__sold-out-overlay {
        position: absolute;
        inset: 0;
        background: rgba(10, 10, 10, 0.55);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        z-index: 2;
        backdrop-filter: blur(0.5px);
      }
      .kwb-related__sold-out {
        background: rgba(255, 255, 255, 0.04);
        border: 1px solid rgba(255, 255, 255, 0.15);
        color: #eeeeee;
        font-size: 11px !important;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 5px 14px;
        border-radius: 30px;
        font-weight: 500;
        transition: all 0.25s ease;
      }
      /* Hover interaction links pill button cleanly to theme colors */
      .kwb-related__item:hover .kwb-related__sold-out {
        border-color: #7a9ab0;
        color: #7a9ab0;
        background: rgba(122, 154, 176, 0.08);
      }
      .kwb-related__sold-out-sub {
        font-size: 10px !important;
        color: #7a9ab0;
        letter-spacing: 0.05em;
        text-transform: uppercase;
      }
      
      .kwb-related__name {
        display: block;
        font-size: 13.5px !important;
        color: #cccccc;
        margin-bottom: 4px;
        line-height: 1.4;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .kwb-related__price {
        display: block;
        font-size: 13px !important;
        color: #777777;
        font-weight: 500;
      }
      .kwb-related__price--sold {
        color: #444444 !important;
        text-decoration: line-through;
      }
      
      .kwb-buy__payments {
        margin-top: 5px;
        font-size: 13px !important;
        color: #8d8c8c;
        text-align: center;
      }
      .kwb-buy__payments .shopify-payment-terms {
        color: #777777 !important;
        margin-bottom: 8px;
      }
      .kwb-scroll-prompt {
        background: #111111;
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 20px 32px;
        border-top: 1px solid rgba(255,255,255,0.06);
      }
      .kwb-scroll-prompt__line {
        flex: 1;
        height: 1px;
        background: rgba(255,255,255,0.1);
      }
      .kwb-scroll-prompt__text {
        font-size: 12px !important;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: #555555;
        white-space: nowrap;
      }

      .kwb-sold-out-banner {
        background-color: #1a1a1a !important;
        border-left: 3px solid #7a9ab0 !important;
        padding: 16px 20px !important;
        margin: 20px 0 !important;
        border-radius: 2px !important;
      }
      .kwb-sold-out-message {
        color: #cccccc !important;
        font-size: 15px !important;
        margin: 0 0 8px 0 !important;
        line-height: 1.5 !important;
      }
      .kwb-sold-out-message strong {
        color: #ffffff !important;
      }
      .kwb-sold-out-link {
        color: #7a9ab0 !important;
        font-weight: 600 !important;
        font-size: 15px !important;
        text-decoration: none !important;
        letter-spacing: 0.02em !important;
      }
      .kwb-sold-out-link:hover {
        color: #7a9ab0 !important;
        text-decoration: underline !important;
      }

      .kwb-accordion {
        border: 1px solid rgba(255,255,255,0.15);
        border-radius: 4px;
        padding: 0 20px;
        margin: 12px 0;
      }
      .kwb-accordion:last-of-type {
        border-bottom: 1px solid rgba(255,255,255,0.15);
      }
      .kwb-accordion__trigger {
        font-size: 14px !important;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
        list-style: none;
        padding: 16px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #7a9ab0;
      }
      .kwb-accordion__trigger::-webkit-details-marker {
        display: none;
      }
      .kwb-accordion__trigger::after {
        content: '+';
        font-size: 18px;
        font-weight: 300;
        flex-shrink: 0;
        color: #7a9ab0;
      }
      details[open] .kwb-accordion__trigger::after {
        content: '−';
      }

      /* ---- SPLIT LAYOUT ---- */
      .kwb-split {
        display: flex;
        flex-direction: column;
        background: #111111;
      }
      @media (min-width: 900px) {
        .kwb-split {
          flex-direction: row;
          align-items: flex-start;
        }
      }

      /* ---- GALLERY FIXED LAYOUT BLOCK ---- */
      .kwb-gallery-wrapper {
        flex: 1 1 55%;
        padding: 0px;
        background: #111111;
        min-width: 0;
      }
      @media (min-width: 900px) {
        .kwb-gallery-wrapper {
          position: sticky;
          top: 20px;
          height: auto !important;
          max-height: none !important;
          overflow: visible !important;
        }
      }
      .kwb-gallery-wrapper .product__media-wrapper,
      .kwb-gallery-wrapper .product__media-list {
        margin: 0 !important;
        padding: 0 !important;
      }

      /* ================= GLOBAL DESKTOP CONTAINER CENTERING ================= */
      .kwb-knife {
        max-width: 1400px !important;
        margin-left: auto !important;
        margin-right: auto !important;
        background-color: #111111 !important;
        width: 100% !important;
      }

      /* ============ KWB RECONSTRUCTED ADDONS LAYOUT ============ */
      .kwb-addons {
        padding: 24px 0 12px;
        border-top: 1px solid rgba(255,255,255,0.06);
        margin-top: 24px;
      }
      .kwb-addons__header {
        margin-bottom: 16px;
      }
      .kwb-addons__title {
        font-size: 12px !important;
        font-weight: 500;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: #666666;
      }
     
      .kwb-addons__cards {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 95px));
        gap: 16px;
        margin-bottom: 8px;
      }
     
      @media (max-width: 480px) {
        .kwb-addons__cards {
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 12px;
        }
      }
     
      .kwb-addons__card {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        position: relative;
        background: transparent;
      }
     
      .kwb-addons__card-image-box {
        position: relative;
        width: 100%;
        aspect-ratio: 1 / 1 !important;
        overflow: hidden;
        background: #151515;
        border: 1px solid rgba(255,255,255,0.05);
        border-radius: 3px;
        transition: border-color 0.25s ease;
      }
      .kwb-addons__card:hover .kwb-addons__card-image-box {
        border-color: rgba(122,154,176,0.4);
      }
     
      .kwb-addons__card-img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        display: block;
        transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      }
      .kwb-addons__card:hover .kwb-addons__card-img {
        transform: scale(1.03);
      }
     
      .kwb-addons__card-zoom {
        position: absolute;
        bottom: 4px;
        right: 6px;
        font-size: 13px;
        color: rgba(255,255,255,0.3);
        transition: color 0.2s;
        pointer-events: none;
      }
      .kwb-addons__card:hover .kwb-addons__card-zoom {
        color: #7a9ab0;
      }
     
      .kwb-addons__card-info {
        padding-top: 8px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
      }
      .kwb-addons__card-name {
        font-size: 12px !important;
        font-weight: 400;
        color: #b5b5b5;
        line-height: 1.3;
        display: block;
        margin-bottom: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .kwb-addons__card-price {
        font-size: 12px !important;
        color: #777777;
        display: block;
        font-weight: 500;
        margin-bottom: 6px;
      }
     
      .kwb-addons__card-actions {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      .kwb-addons__card-btn--add {
        width: 100%;
        background: rgba(255,255,255,0.03);
        color: #999;
        border: 1px solid rgba(255,255,255,0.08);
        padding: 4px 6px;
        font-size: 10.5px !important;
        font-weight: 500;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        cursor: pointer;
        border-radius: 2px;
        transition: all 0.2s ease;
        font-family: inherit;
      }
      .kwb-addons__card-btn--add:hover {
        background: #2a7a4b;
        color: #fff;
        border-color: #2a7a4b;
      }
      .kwb-addons__card-view-details {
        display: block;
        text-align: center;
        font-size: 11px !important;
        color: #555;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-top: 4px;
        transition: color 0.2s;
      }
      .kwb-addons__card:hover .kwb-addons__card-view-details {
        color: #7a9ab0;
      }

      /* ============ LIGHTBOX LAYOUT REFINEMENTS ============ */
      .kwb-lightbox {
        position: fixed;
        inset: 0;
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
      }
      .kwb-lightbox[aria-hidden="false"] {
        opacity: 1;
        pointer-events: auto;
      }
      .kwb-lightbox__backdrop {
        position: absolute;
        inset: 0;
        background: rgba(10, 10, 10, 0.85);
        backdrop-filter: blur(8px);
      }
      .kwb-lightbox__panel {
        position: relative;
        background: #141414;
        border: 1px solid rgba(255,255,255,0.06);
        width: 90%;
        max-width: 440px;
        border-radius: 6px;
        overflow: hidden;
        z-index: 2;
        box-shadow: 0 20px 40px rgba(0,0,0,0.5);
        transform: translateY(15px);
        transition: transform 0.3s ease;
      }
      .kwb-lightbox[aria-hidden="false"] .kwb-lightbox__panel {
        transform: translateY(0);
      }
      .kwb-lightbox__close {
        position: absolute;
        top: 14px;
        right: 14px;
        background: none;
        border: none;
        color: #666;
        font-size: 16px;
        cursor: pointer;
        transition: color 0.2s;
        z-index: 10;
      }
      .kwb-lightbox__close:hover {
        color: #fff;
      }
      .kwb-lightbox__content {
        padding: 28px 24px;
      }
      .kwb-lightbox-title {
        font-size: 18px !important;
        font-weight: 400;
        color: #fff;
        margin: 0 0 6px 0;
        letter-spacing: 0.02em;
      }
      .kwb-lightbox-price {
        font-size: 14px !important;
        color: #7a9ab0;
        font-weight: 500;
        margin-bottom: 16px;
        display: block;
      }
      .kwb-lightbox-desc {
        font-size: 14px !important;
        line-height: 1.6;
        color: #8c8c8c;
        margin: 0 0 20px 0;
      }

      /* Options Pills Styling Container Section */
      .kwb-lightbox-options {
        margin-bottom: 24px;
        border-top: 1px solid rgba(255,255,255,0.05);
        padding-top: 16px;
      }
      .kwb-lightbox-options__label {
        font-size: 11px !important;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: #666;
        display: block;
        margin-bottom: 8px;
      }
      .kwb-lightbox-pills {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }
      .kwb-lightbox-pill {
        background: rgba(255,255,255,0.02);
        border: 1px solid rgba(255,255,255,0.1);
        color: #aaa;
        padding: 6px 14px;
        font-size: 12px !important;
        border-radius: 30px;
        cursor: pointer;
        transition: all 0.2s ease;
      }
      .kwb-lightbox-pill:hover {
        border-color: rgba(122,154,176,0.4);
        color: #fff;
      }
      .kwb-lightbox-pill--active {
        background: rgba(122,154,176,0.08);
        border-color: #7a9ab0;
        color: #7a9ab0;
      }

      .kwb-lightbox-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        border-top: 1px solid rgba(255,255,255,0.05);
        padding-top: 16px;
      }
      .kwb-lightbox-link {
        font-size: 12px !important;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #555;
        text-decoration: none;
        border-bottom: 1px solid transparent;
        padding-bottom: 2px;
        transition: all 0.2s ease;
      }
      .kwb-lightbox-link:hover {
        color: #7a9ab0;
        border-color: #7a9ab0;
      }
      .kwb-lightbox-modal-add {
        background: #2a7a4b;
        color: #fff;
        border: none;
        padding: 8px 16px;
        font-size: 12px !important;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        border-radius: 20px;
        cursor: pointer;
        transition: background 0.2s;
      }
      .kwb-lightbox-modal-add:hover {
        background: #348f5a;
      }
      .kwb-lightbox__loading {
        text-align: center;
        padding: 40px 0;
      }
      .kwb-lightbox__spinner {
        display: inline-block;
        width: 24px;
        height: 24px;
        border: 2px solid rgba(255,255,255,0.05);
        border-radius: 50%;
        border-top-color: #7a9ab0;
        animation: kwb-spin 0.8s linear infinite;
      }
      @keyframes kwb-spin {
        to { transform: rotate(360deg); }
      }
  `;
  document.head.appendChild(style);

  // ============ ADDONS & LIGHTBOX FUNCTIONAL LOGIC ============
  const lightbox = document.getElementById('kwb-lightbox');
  const backdrop = document.getElementById('kwb-lightbox-backdrop');
  const closeBtn = document.getElementById('kwb-lightbox-close');
  const contentContainer = document.getElementById('kwb-lightbox-content');

  let activeProductData = null;
  let activeSelectedVariant = null;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP'
    });
  }

  function updateModalDOM() {
    if (!contentContainer || !activeProductData || !activeSelectedVariant) return;

    const secureText = activeProductData.description 
      ? activeProductData.description.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 160) + "..."
      : "Artisanal hand-crafted premium knife accessory component.";

    let optionsHTML = '';
    const isDisplayStand = activeProductData.handle.includes('stand');

    if (isDisplayStand) {
      try {
        const engravingOptionIndex = activeProductData.options.findIndex(opt => opt.name && opt.name.toLowerCase().includes('engrav'));
        const balanceOptionIndex = activeProductData.options.findIndex(opt => opt.name && opt.name.toLowerCase().includes('balanc'));

        if (engravingOptionIndex !== -1 && balanceOptionIndex !== -1) {
          const currentBalanceVal = activeSelectedVariant['option' + (balanceOptionIndex + 1)];
          
          if (currentBalanceVal) {
            const optionsValues = Array.from(new Set(activeProductData.variants
              .filter(v => v['option' + (balanceOptionIndex + 1)] === currentBalanceVal)
              .map(v => v['option' + (engravingOptionIndex + 1)])
              .filter(val => val && val.trim() !== "")
            ));

            if (optionsValues.length > 0) {
              optionsHTML = `
                <div class="kwb-lightbox-options">
                  <span class="kwb-lightbox-options__label">Custom Engraving</span>
                  <div class="kwb-lightbox-pills">
                    ${optionsValues.map(val => {
                      const isActive = activeSelectedVariant['option' + (engravingOptionIndex + 1)] === val;
                      return `<button class="kwb-lightbox-pill ${isActive ? 'kwb-lightbox-pill--active' : ''}" data-value="${val}">${val}</button>`;
                    }).join('')}
                  </div>
                </div>
              `;
            }
          }
        }
      } catch (optionErr) {
        console.warn("KWB Lightbox options generation skipped gracefully:", optionErr);
      }
    }

    contentContainer.innerHTML = `
      <h3 class="kwb-lightbox-title">${activeProductData.title}</h3>
      <span class="kwb-lightbox-price" id="modal-live-price">${formatMoney(activeSelectedVariant.price)}</span>
      <p class="kwb-lightbox-desc">${secureText}</p>
      ${optionsHTML}
      <div class="kwb-lightbox-footer">
        <a href="/products/${activeProductData.handle}" target="_blank" class="kwb-lightbox-link">Open Full Product Listing ↗</a>
        <button class="kwb-lightbox-modal-add" id="modal-checkout-add-btn">Add to Basket</button>
      </div>
    `;

    if (isDisplayStand) {
      const engravingOptionIndex = activeProductData.options.findIndex(opt => opt.name && opt.name.toLowerCase().includes('engrav'));
      const balanceOptionIndex = activeProductData.options.findIndex(opt => opt.name && opt.name.toLowerCase().includes('balanc'));

      contentContainer.querySelectorAll('.kwb-lightbox-pill').forEach(pill => {
        pill.addEventListener('click', function() {
          const selectedValue = this.getAttribute('data-value');
          const currentBalanceVal = activeSelectedVariant['option' + (balanceOptionIndex + 1)];
          
          const newVariant = activeProductData.variants.find(v => 
            v['option' + (balanceOptionIndex + 1)] === currentBalanceVal && 
            v['option' + (engravingOptionIndex + 1)] === selectedValue
          );

          if (newVariant) {
            activeSelectedVariant = newVariant;
            updateModalDOM();
          }
        });
      });
    }

    const modalAddBtn = document.getElementById('modal-checkout-add-btn');
    if (modalAddBtn) {
      modalAddBtn.addEventListener('click', function() {
        executeBackgroundFormSubmission(activeSelectedVariant.id, this);
      });
    }
  }

  function openLightbox(productHandle, initialVariantId = null) {
    if (!lightbox || !contentContainer) return;
    
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    contentContainer.innerHTML = `
      <div class="kwb-lightbox__loading">
        <span class="kwb-lightbox__spinner"></span>
      </div>
    `;

    fetch('/products/' + productHandle + '.js')
      .then(res => {
        if (!res.ok) throw new Error('Product endpoint error');
        return res.json();
      })
      .then(product => {
        activeProductData = product;
        activeSelectedVariant = product.variants[0];
        
        if (initialVariantId) {
          let found = product.variants.find(v => v.id == initialVariantId);
          if (found) {
            activeSelectedVariant = found;
          }
        }
        
        updateModalDOM();
      })
      .catch(err => {
        console.error("KWB Lightbox configuration crash trace:", err);
        contentContainer.innerHTML = `
          <p class="kwb-lightbox-desc" style="color:#d9534f;">Failed to resolve accessory description detail dynamically.</p>
        `;
      });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activeProductData = null;
    activeSelectedVariant = null;
  }

  function executeBackgroundFormSubmission(variantId, submitBtn) {
    if (!submitBtn || submitBtn.disabled) return;

    const originalText = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML = 'Adding...';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(item => {
      submitBtn.innerHTML = '✓ Added';
      submitBtn.style.backgroundColor = '#1e5433';
      
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      if (window.theme && window.theme.CartNotification) {
        document.dispatchEvent(new CustomEvent('ajaxProductAdded', { detail: { product: item } }));
      }

      setTimeout(() => {
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
        submitBtn.style.backgroundColor = '';
        closeLightbox();
      }, 1000);
    })
    .catch(err => {
      console.error('AJAX Cart Error:', err);
      submitBtn.innerHTML = 'Error';
      setTimeout(() => {
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
      }, 2000);
    });
  }

  document.querySelectorAll('.kwb-addons__card').forEach(card => {
    card.addEventListener('click', function(e) {
      let handle = this.getAttribute('data-product-handle');
      
      if (!handle || handle.trim() === "") {
        const form = this.querySelector('form');
        if (form && form.getAttribute('action')) {
          const parts = form.getAttribute('action').split('/products/');
          if (parts[1]) handle = parts[1].split('?')[0];
        }
      }

      const formInput = this.querySelector('input[name="id"]');
      const variantId = formInput ? formInput.value : null;

      if (handle && handle.trim() !== "") {
        openLightbox(handle.trim(), variantId);
      }
    });
  });

  document.querySelectorAll('.kwb-addons__card-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const submitBtn = this.querySelector('button[type="submit"]');
      const formInput = this.querySelector('input[name="id"]');
      if (formInput && submitBtn) {
        executeBackgroundFormSubmission(formInput.value, submitBtn);
      }
    });
  });

  if (backdrop) backdrop.addEventListener('click', closeLightbox);
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeLightbox();
  });
})();

/* ============ BACKGROUND VARIANT HIDER HANDLERS ============ */
document.addEventListener('DOMContentLoaded', function () {
  const pathParts = window.location.pathname.split('/products/');
  if (!pathParts[1]) return;
  const productHandle = pathParts[1].split('?')[0];

  fetch('/products/' + productHandle + '.js')
    .then(res => res.json())
    .then(product => {
      applyVisibility(product);
      document.addEventListener('change', function (e) {
        if (e.target.type === 'radio') applyVisibility(product);
      });
    })
    .catch(err => console.warn('KWB variant hider:', err));

  function getCheckedValue(product, optionIndex) {
    const optionKey = 'option' + (optionIndex + 1);
    const allValues = Array.from(new Set(product.variants.map(v => v[optionKey])));
    for (const value of allValues) {
      const escapedValue = value.replace(/'/g, "\\'").replace(/"/g, '\\"');
      const input = document.querySelector(
        'input[type="radio"][value="' + escapedValue + '"]:checked'
      );
      if (input) return value;
    }
    return null;
  }

  function setPillVisibility(value, visible) {
    const escapedValue = value.replace(/'/g, "\\'").replace(/"/g, '\\"');
    document.querySelectorAll('input[type="radio"][value="' + escapedValue + '"]')
      .forEach(input => {
        const label = document.querySelector('label[for="' + input.id + '"]');
        input.style.display = visible ? '' : 'none';
        if (label) label.style.display = visible ? '' : 'none';
      });
  }

  function applyVisibility(product) {
    const variants = product.variants;
    const options = product.options;

    options.forEach((_, optionIndex) => {
      const optionKey = 'option' + (optionIndex + 1);
      const allValues = Array.from(new Set(variants.map(v => v[optionKey])));

      allValues.forEach(value => {
        let isAvailable;

        if (optionIndex === 0) {
          isAvailable = variants.some(v => v[optionKey] === value && v.available);
        } else {
          const primarySelected = getCheckedValue(product, 0);
          isAvailable = variants.some(v => {
            if (!v.available) return false;
            if (v[optionKey] !== value) return false;
            if (primarySelected && v.option1 !== primarySelected) return false;
            return true;
          });
        }
        setPillVisibility(value, isAvailable);
      });
    });
  }

  // KWB Testimonial Carousel
  document.querySelectorAll('.kwb-testimonials__track').forEach(track => {
    const items = track.querySelectorAll('.kwb-testimonials__item');
    const container = track.closest('.kwb-testimonials');
    const dotsContainer = container ? container.querySelector('.kwb-testimonials__dots') : null;
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.kwb-testimonials__dot') : null;

    if (items.length === 0) return;
    items[0].classList.add('kwb-active');
    if (!dots || dots.length === 0) return;

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        items.forEach(i => i.classList.remove('kwb-active'));
        dots.forEach(d => d.classList.remove('kwb-testimonials__dot--active'));
        items[index].classList.add('kwb-active');
        dot.classList.add('kwb-testimonials__dot--active');
      });
    });
  });
});

